// Returns "#111827" (near-black) or "#FFFFFF" depending on which gives
// better contrast against the given hex background — a simplified WCAG
// relative-luminance check, so text stays readable no matter what
// background color someone picks in the template designer.
export const getReadableTextColor = (hexColor) => {
  if (!hexColor) return "#111827"
  const hex = hexColor.replace("#", "")
  const full = hex.length === 3 ? hex.split("").map((c) => c + c).join("") : hex
  if (full.length !== 6) return "#111827"

  const r = parseInt(full.substring(0, 2), 16)
  const g = parseInt(full.substring(2, 4), 16)
  const b = parseInt(full.substring(4, 6), 16)

  const [rl, gl, bl] = [r, g, b].map((v) => {
    const c = v / 255
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)
  })
  const luminance = 0.2126 * rl + 0.7152 * gl + 0.0722 * bl

  return luminance > 0.5 ? "#111827" : "#FFFFFF"
}

// A softer variant for secondary/muted text (labels, footer) — same base
// color, reduced via opacity in the className rather than a separate hex,
// so it still tracks the background correctly.
export const getMutedTextColor = (hexColor) => getReadableTextColor(hexColor)